import React from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useForm, usePage } from "@inertiajs/inertia-react";
import { SelectStyles } from "../../../styles/ReactSelect";
import CustomerLayout from "../../../Layouts/CustomerLayout";

// Public inquiry form for Tradesman Domestic. Reachable without an account:
// anonymous submissions are stashed server-side and created after signup.
const RequestForm = ({ trades }) => {
  const { customer } = usePage().props;

  const { data, setData, post, processing } = useForm({
    description: "",
    trade_ids: [],
    ideal_start_date: "",
    postcode: "",
  });

  const tradeOptions = trades.map((t) => ({ value: t.id, label: t.name }));

  function submit(e) {
    e.preventDefault();
    post("/domestic/requests");
  }

  const form = (
    <form onSubmit={submit} className="space-y-6 max-w-2xl">
      <div>
        <label className="block text-sm font-medium text-gray-700">
          What do you need done?
        </label>
        <textarea
          rows={5}
          required
          value={data.description}
          onChange={(e) => setData("description", e.target.value)}
          placeholder="Describe the work you need doing…"
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-orange-500 focus:outline-none focus:ring-orange-500 sm:text-sm"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Trades required
        </label>
        <Select
          isMulti
          options={tradeOptions}
          styles={SelectStyles}
          value={tradeOptions.filter((o) => data.trade_ids.includes(o.value))}
          onChange={(selected) =>
            setData(
              "trade_ids",
              (selected || []).map((o) => o.value)
            )
          }
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Ideal start date
        </label>
        <DatePicker
          selected={data.ideal_start_date ? new Date(data.ideal_start_date) : null}
          onChange={(date) =>
            setData(
              "ideal_start_date",
              date ? date.toISOString().slice(0, 10) : ""
            )
          }
          minDate={new Date()}
          dateFormat="dd/MM/yyyy"
          placeholderText="Pick a date"
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-orange-500 focus:outline-none focus:ring-orange-500 sm:text-sm"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Property postcode
        </label>
        <p className="text-xs text-gray-500 mb-1">
          Used to match you with tradespeople covering your area — only your
          postcode district (e.g. KT22) is shown to them.
        </p>
        <input
          type="text"
          required
          value={data.postcode}
          onChange={(e) => setData("postcode", e.target.value)}
          placeholder="e.g. KT22 7EX"
          className="mt-1 block w-full max-w-xs rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-orange-500 focus:outline-none focus:ring-orange-500 sm:text-sm"
        />
      </div>

      <button
        type="submit"
        disabled={processing || data.trade_ids.length === 0}
        className="inline-flex justify-center rounded-md border border-transparent bg-orange-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:opacity-50"
      >
        {customer ? "Submit request" : "Continue — create account & send"}
      </button>
    </form>
  );

  if (customer) {
    return <CustomerLayout title="Submit a Request">{form}</CustomerLayout>;
  }

  return (
    <div className="min-h-full py-12 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-2xl">
        <img className="h-10 w-auto" src="/images/logo.svg" alt="The Tradesman App" />
        <h1 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
          Tradesman Domestic
        </h1>
        <p className="mt-2 text-sm text-gray-600">
          Tell us what you need done and we&apos;ll put your request in front
          of local tradespeople.
        </p>
        <div className="mt-8">{form}</div>
      </div>
    </div>
  );
};

export default RequestForm;
